
export default {
    accessibility: false,
    /* Set by one bar after successfully logging in to AM.
     * sessionId needs to be passed in the header to REST calls to AM services.  */
    amSessionId: '',
    authTokenCreated: false, // use this new flag for new sso dh authentication, we set this to true when ssodh token is created. When this is true, we will authenticate to iserver, md server, hmds server separately
    brandInfo: {}, // white label information
    /* after /validate */
    ssoValidated: false,
    /* Accounts from the account picker,
     * accountId, accountTitle, accountDisplay, parent (null if root)
     * Once validated they are stored as selectedAccounts
     * In development the list could be:
     * a) The list of portfolio accounts as provided by IBCust
     * b) The list of iserver accounts as provided by IServer
     * The reason for b) is that some paper users don't exists in QA IBCust yet. */
    selectedAccounts: [],
    //store all validated accounts, will be set only once
    allAccounts: [],
    sso: {
        features: {}
    }, // after sso validate; response from server is stored in this object
    balanceSummary: {},
    competitors: [],
    fundamentals: [],


    /**
     * Used to keep track of callbacks/listeners to events:
     * {
     *  'key-event': [cb1, cb2, cb3]
     * }
     **/
    events: {
        'ON_UAR_CHANGED': [],
        'ON_USER': [],
        'ON_SSO_VALIDATED': [],
        'ON_LOGIN_FAILED': [],
        'ON_NAVIGATE': [],
        'ON_LOGOUT': [],
        'ON_MOUNTED': [],
        'ON_MOBILE_MENU': [], // deprecated
        'ON_ACCOUNT_SELECTOR': [],
        'ON_USER_SETTINGS': [],
        'ON_ISERVER_AUTHENTICATED': [],
        'ON_SNAPSHOT_ALERT': [],
        'ON_ORDER_EXECUTED': [],
        //For components communication
        'ACCOUNT_SELECTOR_ERROR': [],
        'CALENDAR_OPEN_FILTERS': [],
        'CALENDAR_GET_EVENTS': [],
        'CALENDAR_RESET': [],
        'CALENDAR_SYM_SEARCH': [],
        'NEXT_FOCUS': [],
        'PREVIOUS_FOCUS': [],
        'SL_SYM_SEARCH': [],
        'TOGGLE_PROMOTION': [],
        '*': []
    },

    optionCombo: {}, //store ticker and conid for option chains header, could store more as needed later
    markets: [],
    marketData: {},
    secdefData: {}, // coming from trserv
    marketsInfo: [],
    marketHistory: {},
    news: [],
    newsContent: [],
    performance: {},
    period: '1Y',
    pnl: [],
    upnl: {},
    positions: [], // { name: model-name, positions: [] }
    positionsTotalNum: [],
    priceHistory: [],
    rates: {},
    user: {
        username: '',
        uar: {
            portfolioAnalyst: false,
            userInfo: false,
            messageCenter: false,
            accountDetails: false,
            tradingRestrictions: false,
            tws: false,
            fyi: false,
            voting: false,
            forum: false
        },
        features: {
            qt: false,
            ibot: false
        },
        props: {
            readOnlySession: false,
            isIBAMClient: false
        }
    },
    /* Map is built from all ENV variables which are collected from the environment or from the build/* file */
    features: process.env,

    /** This property is deprecated, please do not use it in the future
     * Please visit the JIRA CLNTPORTAL-1888 for more details
     */
    uar: {
        portfolioAnalyst: false
    },
    showInBase: false, //show values in base currency or local currency
    fromMobile: false, //for testing
    isCurInComMd: undefined, //for orderpriceinfo
    isInCompleteConidSel: false, //for Orderpane
    faviconUrl: '',  // favicon image URL
    notificationIconUrl: '', // icon URL for notification
    pickerAccounts: [], // contains all AM accounts
    routeLoading: false, // true when route switch is in progress
    privacyMode: false, // true if user is in privacy mode
    accountProperties: undefined, // account properties
    amStatus: undefined, // Account Management status
    isAccountTaskPending: false, // POA, EDD, PEP task status
    forceShowIBKeyWidget: false, // IB Key widget homepage
    forceShowCryptoPopover: false, // Crypto widget homepage
    isTestingCryptoPos: false,
}
